<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" :disable-backdrop-click="loading">
    <div class="mx-auto w-full max-w-lg">
      <BaseVeeForm
        :action="storeAccProduct"
        ensure-error-keys-camel-case
        v-slot="{ isPending, invalid }"
        class="space-y-8"
      >
        <BaseCard>
          <BaseCardHeader> Create Acc Product </BaseCardHeader>
          <BaseCardBody>
            <AccProductCreateForm ref="accProductForm" :disabled="isPending || loading" />
          </BaseCardBody>
          <BaseCardFooter>
            <div class="flex space-x-2">
              <BaseButton primary :disabled="invalid || isPending || loading"> Create </BaseButton>
              <BaseButton
                type="button"
                primary
                outline
                :disabled="isPending || loading"
                @click="$refs.modal.close()"
              >
                Cancel
              </BaseButton>
            </div>
          </BaseCardFooter>
        </BaseCard>
      </BaseVeeForm>
    </div>
  </VModal>
</template>

<script>
import AccProductCreateForm from './AccProductCreateForm.vue';

export default {
  components: { AccProductCreateForm },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async storeAccProduct() {
      try {
        this.loading = true;

        const formData = this.$refs?.accProductForm?.getFormData() || {};

        const accProductId = await this.$store.dispatch('ui/accountAccProducts/store', {
          id: this.accountId,
          formData,
        });

        this.$emit('created', accProductId);

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
